import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import {
    WelcomeScreen,
    LoginScreen,
    RegisterScreen,
    CourseDetailsScreen,
    LogoScreen,
} from '../screens';
import { View, StyleSheet, TouchableHighlight } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import Icon from '../components/shared/Icon';
import TabsNavigator from './TabsNavigator';
import { useSelector } from 'react-redux';
import ToplearnText from './../components/shared/ToplearnText';

const StackNavigator = ({ navigation }) => {
    const user = useSelector((state) => state.user);

    const Stack = createStackNavigator();
    // const handleLogout = async () => {
    //     await AsyncStorage.removeItem('token');
    //     await AsyncStorage.removeItem('userId');
    //     try {
    //         navigation.dispatch(StackActions.replace('Welcome'));
    //     } catch (err) {
    //         console.log(err);
    //     }
    // };
    return (
        <Stack.Navigator screenOptions={{ headerShown: false }}>
            <Stack.Screen name="Welcome" options={{ title: 'خوش آمدید' }} component={WelcomeScreen} />
            <Stack.Screen
                name="Login"
                options={{ title: 'صفحه ورود' }}
                component={LoginScreen}
                initialParams={{ successRegister: false }}
            />
            <Stack.Screen name="Register" options={{ title: 'ثبت نام' }} component={RegisterScreen} />
            <Stack.Screen
                name="Home"
                options={{ title: 'خانه' }}
                component={TabsNavigator}
                options={{
                    headerShown: true,
                    headerStyle: {
                        backgroundColor: 'light',
                    },
                    // headerRight: () => (
                    //     <View style={styles.container}>
                    //         <TouchableHighlight
                    //             underlayColor="#f8f4f4"
                    //             onPress={handleLogout}
                    //         >
                    //             <View style={styles.container}>
                    //                 <Icon
                    //                     name="logout"
                    //                     backgroundColor="tomato"
                    //                 />
                    //             </View>
                    //         </TouchableHighlight>
                    //         {/* <Icon name="logout" backgroundColor="tomato" /> */}
                    //     </View>
                    // ),
                    headerLeft: () => (
                        <View style={styles.container}>
                            <LogoScreen />
                        </View>
                    ),
                    headerTitleAlign: 'center',
                    headerTitle: () => {
                        return (
                            <View style={styles.usrLoginScreen}>
                                <ToplearnText
                                    fontFamily="yekan"
                                    size="1.7"
                                    color="black"
                                >
                                    {user.firstName} {user.lastName}
                                </ToplearnText>
                                <ToplearnText
                                    fontFamily="yekan"
                                    size="1.3"
                                    color="tomato"
                                >
                                    شناسه {user.shenaseh}
                                </ToplearnText>
                            </View>
                        );
                    },
                }}
            />
            <Stack.Screen
                name="CourseDetails"
                component={CourseDetailsScreen}
            />
        </Stack.Navigator>
    );
};

export default StackNavigator;
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        //marginVertical: 20,
        padding: 15,
    },
    usrLoginScreen: {
        alignItems: 'center',
    },
    screen: {
        backgroundColor: '#f8f4f4',
    },
    image: {
        width: 100,
        height: 100,
        borderRadius: 35,
    },
    details: {
        marginLeft: 10,
        justifyContent: 'center',
    },
    subTitle: {
        color: '#6e6969',
    },
    settings: {
        alignSelf: 'center',
        marginLeft: 20,
    },
});
